import cx from 'classnames'
import { DateInput, DateSegment } from 'react-aria-components'

type Props = {
  isInError: boolean
  isDisabled: boolean
}

export const DateField = ({ isDisabled, isInError }: Props) => (
  <DateInput className="font-mono">
    {(segment) => {
      const isEmpty = segment.text === '\u2066'
      const hasInteraction = segment.type !== 'literal' || isDisabled
      const zeroWidthSpace = '\u200B' // hack to fix de-focus issues: https://github.com/adobe/react-spectrum/issues/3164#issuecomment-3399961723
      return (
        <>
          {zeroWidthSpace}
          <DateSegment
            segment={segment}
            data-autofocus={
              segment.isEditable && !isDisabled ? true : undefined
            }
            className={cx(
              'relative',
              isEmpty && 'hidden',
              hasInteraction
                ? '-m-px p-px outline-hidden focus-visible:ring-0 focus-visible:text-amaze-inkBright focus-visible:opacity-100 transition-colors z-1'
                : 'opacity-50',
              segment.isPlaceholder && 'opacity-50',
              isInError
                ? 'focus-visible:bg-red-500'
                : 'focus-visible:bg-primary',
            )}
          >
            {({ text }) =>
              // Intl has no 4-digit year option, so `shouldForceLeadingZeros` leaves years like 12 unpadded.
              segment.type === 'year' &&
              !segment.isPlaceholder &&
              /^\d{1,3}$/.test(text)
                ? text.padStart(4, '0')
                : text
            }
          </DateSegment>
          {zeroWidthSpace}
        </>
      )
    }}
  </DateInput>
)
